import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonGroup from '../RadioButton/RadioButtonGroup';
import { ItemPickerStyles } from './ItemPicker.styled';

const ItemPicker = ({ id, items, defaultValue, selectedValue, onChange }) => {
  return (
    <ItemPickerStyles>
      <RadioButtonGroup
        isLayoutHorizontal={true}
        id={id}
        onChange={onChange}
        items={items}
        selectedValue={selectedValue}
        defaultValue={defaultValue}
      />
    </ItemPickerStyles>
  );
};

ItemPicker.defaultProps = {
  id: '',
  items: [],
  defaultValue: '',
  selectedValue: '',
  onChange: null,
};

ItemPicker.propTypes = {
  id: PropTypes.string,
  items: PropTypes.array,
  defaultValue: PropTypes.string,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
};

export default ItemPicker;
